import template from './contact-body.pug';

export const ContactBodyComponent = {
  template,
  bindings: {
    filter: '<',
    records: '<',
    checkedIds: '<',
    onCheck: '&',
    gridOptions: '<?',
    loading: '<?',
    onFilterChange: '&',
    onPageChange: '&',
    isModal: '<?',
    isMobile: '<?'
  },
  controller: class ContactBodyComponent {
    constructor(Contact, $async, $log) {
      'ngInject';
      this.Contact = Contact;
      this.$log = $log;
      this.loadMore = $async(this.loadMore.bind(this));
    }


    // $onInit() {

    // }

    async loadMore() {
      this.filter.page++;
      try {
        const { data } = await this.Contact.getRecords(this.filter);
        console.log(data);
        this.records.push(...data);
      } catch (error) {
        this.$log.error(error);
      }
    }

    applyFilter({ filter, searchId }) {
      this.onFilterChange({
        $event: { filter, searchId }
      });
    }

    checkIds({ checkedIds }) {
      this.onCheck({
        $event: { checkedIds }
      });
    }
  }
};
